import type { ReactNode } from "react"

interface CardProps {
  children: ReactNode
  className?: string
  padding?: "none" | "sm" | "md" | "lg"
  hover?: boolean
}

export function Card({
  children,
  className = "",
  padding = "md",
  hover = false,
}: CardProps) {
  const baseStyles = "bg-white rounded-lg shadow-md overflow-hidden"

  const paddingStyles = {
    none: "",
    sm: "p-4",
    md: "p-6",
    lg: "p-8",
  }

  const hoverStyles = hover
    ? "transition-transform hover:scale-105 hover:shadow-lg cursor-pointer"
    : ""

  return (
    <div
      className={`${baseStyles} ${paddingStyles[padding]} ${hoverStyles} ${className}`}
    >
      {children}
    </div>
  )
}
